export default "__VITE_ASSET__DIXsAcnK__$_?url__"